export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  views: number;
  isHot: boolean;
  isFeatured: boolean;
  tags: string[];
}

export const categories = [
  { slug: 'entertainment', name: '娱乐' },
  { slug: 'finance', name: '财经' },
  { slug: 'tech', name: '科技' },
  { slug: 'lifestyle', name: '生活' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '韩国流行音乐全球影响力持续攀升，K-POP产业规模突破百亿美元',
    excerpt: '据最新报告显示，韩国流行音乐产业在2026年上半年全球营收突破120亿美元，亚洲市场贡献超过六成份额，K-POP已成为亚洲文化输出的标杆产业。',
    content: `<p>据韩国文化振兴院最新发布的报告显示，2026年上半年韩国流行音乐（K-POP）产业全球营收突破120亿美元，较去年同期增长15.3%。其中亚洲市场贡献了超过六成的份额，日本、中国和东南亚地区成为最主要的增长引擎。</p><p>报告指出，以BTS、BLACKPINK为代表的韩国偶像团体持续扩大全球影响力，新生代团体如NewJeans、IVE等也在快速崛起。K-POP的商业模式已经从单纯的音乐销售，扩展至演唱会、周边商品、品牌代言、影视剧等多个领域。</p><p>韩国政府也在积极推动K-POP产业的国际化，通过设立专项基金、举办全球选秀活动、支持海外巡演等方式，助力韩国流行文化走向世界。业内专家分析认为，K-POP已成为亚洲文化输出的标杆产业，其成功经验值得其他亚洲国家借鉴。</p><blockquote><p>K-POP不仅仅是一种音乐形式，它代表的是亚洲流行文化在全球舞台上的崛起。——韩国文化振兴院院长金泰勋</p></blockquote><p>与此同时，中国、日本、泰国等亚洲国家的音乐产业也在加速发展，亚洲流行音乐的全球化进程正在全面推进。</p>`,
    category: 'entertainment',
    categoryName: '娱乐',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20K-pop%20concert%20stage%20with%20colorful%20lighting%20and%20energetic%20performers%20in%20stylish%20outfits%20performing%20on%20stage%20with%20enthusiastic%20audience%20waving%20light%20sticks%20professional%20concert%20photography%20with%20dramatic%20lighting%20and%20atmospheric%20stage%20effects&width=800&height=500&seq=article-kpop-01&orientation=landscape',
    author: '张艺琳',
    date: '2026-08-10',
    views: 125800,
    isHot: true,
    isFeatured: true,
    tags: ['K-POP', '韩国', '音乐产业', '文化输出', '亚洲流行'],
  },
  {
    id: '2',
    title: '日本央行维持宽松货币政策，日元汇率持续承压',
    excerpt: '日本央行在最新货币政策会议上宣布维持超低利率不变，日元兑美元汇率跌破150关口，市场关注日本政府是否会出手干预汇市。',
    content: `<p>日本央行在8月货币政策会议上以多数票决定维持当前超宽松货币政策不变，将短期利率维持在-0.1%的水平，同时将10年期国债收益率目标维持在0%附近。这一决定符合市场普遍预期。</p><p>受此消息影响，日元兑美元汇率在亚洲交易时段跌破150.50关口，创下近三个月新低。市场分析人士指出，日本央行与其他主要央行之间的货币政策分化是导致日元持续走弱的主要原因。</p><p>日本财务大臣铃木俊一在会后表示，政府正密切关注汇率走势，必要时将采取适当措施应对过度波动。然而，市场普遍认为，在美联储维持高利率的背景下，日本政府的口头干预效果有限。</p><blockquote><p>日本央行的政策立场短期内不会改变，这将继续对日元构成下行压力。——野村证券首席经济学家田中健一</p></blockquote><p>与此同时，日本通胀数据出现回升迹象，7月核心CPI同比上涨3.2%，连续第28个月超过央行2%的目标水平。</p>`,
    category: 'finance',
    categoryName: '财经',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Tokyo%20financial%20district%20skyline%20with%20high-rise%20buildings%20and%20Japanese%20flags%20warm%20sunset%20lighting%20professional%20architectural%20photography%20clean%20composition%20with%20corporate%20atmosphere&width=800&height=500&seq=article-japan-finance-01&orientation=landscape',
    author: '李明远',
    date: '2026-08-11',
    views: 89300,
    isHot: true,
    isFeatured: false,
    tags: ['日本', '央行', '货币政策', '日元', '汇率'],
  },
  {
    id: '3',
    title: '中国AI大模型竞赛白热化：百度、字节跳动、阿里相继发布新一代产品',
    excerpt: '中国人工智能领域竞争日趋激烈，百度文心一言4.0、字节跳动豆包大模型2.0、阿里通义千问3.0先后发布，在多项国际基准测试中取得突破性成绩。',
    content: `<p>2026年8月，中国AI大模型领域迎来一波密集的产品发布潮。百度率先发布文心一言4.0版本，在推理、代码生成和多模态理解方面实现了显著提升；随后字节跳动推出了豆包大模型2.0，主打轻量化和低成本部署；阿里巴巴则发布了通义千问3.0，在中文语义理解方面表现突出。</p><p>业内人士分析认为，中国AI大模型已从追赶阶段进入并跑阶段，部分指标甚至达到了国际领先水平。在最新的MMLU、HumanEval等国际基准测试中，国产大模型的综合成绩已接近GPT-4水平。</p><p>值得关注的是，国产大模型在应用落地方面也取得了重要进展。百度文心一言已接入超过20万家企业客户，字节跳动的豆包大模型在抖音电商场景中日均调用量突破10亿次，阿里通义千问则在钉钉办公场景中实现了深度集成。</p><blockquote><p>中国AI产业正在从技术追赶到应用创新转变，这是关键的战略转折点。——清华大学人工智能研究院院长张亚勤</p></blockquote><p>不过，算力瓶颈和高端芯片供应问题仍然是制约中国AI发展的关键因素。</p>`,
    category: 'tech',
    categoryName: '科技',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20abstract%20digital%20brain%20and%20data%20flows%20in%20warm%20amber%20and%20golden%20tones%20clean%20modern%20visual%20design%20with%20geometric%20patterns%20and%20soft%20glowing%20elements&width=800&height=500&seq=article-ai-tech-01&orientation=landscape',
    author: '王科技',
    date: '2026-08-09',
    views: 156200,
    isHot: true,
    isFeatured: true,
    tags: ['AI', '大模型', '百度', '字节跳动', '阿里', '人工智能'],
  },
  {
    id: '4',
    title: '泰国旅游业全面复苏，2026上半年接待国际游客超2000万人次',
    excerpt: '泰国旅游局公布数据显示，2026年上半年泰国共接待国际游客2180万人次，同比增长42%，中国游客重回第一大客源国位置。',
    content: `<p>泰国旅游局最新数据显示，2026年上半年泰国共接待国际游客2180万人次，同比增长42%，已恢复至疫情前2019年同期水平的85%。旅游总收入约1.2万亿泰铢（约合330亿美元），同比增长38%。</p><p>中国游客以420万人次重回第一大客源国位置，较去年同期翻了一番。马来西亚、印度、韩国和俄罗斯分列第二至第五位。泰国旅游局表示，中泰互免签证政策的实施是推动中国游客大幅增长的关键因素。</p><p>泰国政府计划在2026年全年吸引4000万国际游客，实现旅游收入3万亿泰铢的目标。为此，泰国正在加大旅游基础设施建设投入，包括扩建素万那普机场、改善主要旅游城市的交通网络等。</p><blockquote><p>泰国旅游业已经进入全面复苏通道，我们对全年目标充满信心。——泰国旅游局局长育塔萨</p></blockquote><p>此外，泰国也在积极推广二三线旅游城市，如清莱、素可泰、华欣等，以分散游客流量，提升旅游体验质量。</p>`,
    category: 'lifestyle',
    categoryName: '生活',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tropical%20Thai%20beach%20with%20crystal%20clear%20turquoise%20water%20and%20white%20sand%20traditional%20long-tail%20boats%20under%20warm%20golden%20sunlight%20palm%20trees%20swaying%20peaceful%20atmosphere%20professional%20travel%20photography&width=800&height=500&seq=article-thailand-travel-01&orientation=landscape',
    author: '陈美琳',
    date: '2026-08-08',
    views: 67800,
    isHot: false,
    isFeatured: false,
    tags: ['泰国', '旅游', '亚洲旅游', '出境游', '经济复苏'],
  },
  {
    id: '5',
    title: '宝莱坞2026年票房创历史新高，《战士》全球票房突破8亿美元',
    excerpt: '印度宝莱坞电影产业在2026年迎来爆发式增长，由沙鲁克·汗主演的动作大片《战士》全球票房突破8亿美元，刷新印度电影票房纪录。',
    content: `<p>印度宝莱坞电影产业在2026年迎来了历史性的突破。由"宝莱坞之王"沙鲁克·汗主演的动作大片《战士》（Jawan 2）在全球上映后，累计票房突破8亿美元，成为印度电影史上票房最高的影片。</p><p>《战士》的成功不仅体现在票房数字上，更重要的是它展示了宝莱坞电影在全球市场的巨大潜力。影片在北美、中东、东南亚等地区均取得了优异的票房成绩，其中中国内地市场贡献了约1.2亿美元的票房。</p><p>除《战士》外，2026年还有多部印度电影取得不俗成绩。由阿米尔·汗制片的《印度制造》聚焦印度制造业崛起，在全球获得了3.5亿美元票房；南印度电影《RRR》的续集也已宣布开拍。</p><blockquote><p>印度电影正在经历一个黄金时代，我们的故事正在被全世界观众所接受和喜爱。——沙鲁克·汗</p></blockquote><p>业内预计，2026年全年印度电影全球总票房有望突破2500亿卢比（约合30亿美元），创历史新高。</p>`,
    category: 'entertainment',
    categoryName: '娱乐',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Bollywood%20movie%20scene%20with%20colorful%20vibrant%20Indian%20cinema%20aesthetic%20dramatic%20lighting%20traditional%20Indian%20dance%20performance%20on%20elaborate%20stage%20set%20with%20rich%20golden%20and%20crimson%20costumes%20cinematic%20photography&width=800&height=500&seq=article-bollywood-01&orientation=landscape',
    author: '赵亚洲',
    date: '2026-08-07',
    views: 94500,
    isHot: true,
    isFeatured: false,
    tags: ['宝莱坞', '印度电影', '票房', '沙鲁克汗', '亚洲娱乐'],
  },
  {
    id: '6',
    title: '新加坡成为亚洲新兴家族办公室首选地，管理资产规模突破2万亿美元',
    excerpt: '新加坡金融管理局数据显示，截至2026年中，在新加坡注册的家族办公室数量已超过2000家，管理资产总规模突破2万亿美元。',
    content: `<p>新加坡金融管理局最新数据显示，截至2026年6月底，在新加坡注册的单一家族办公室数量已超过2000家，较2024年底增长了约35%。这些家族办公室管理的总资产规模突破2万亿美元，使新加坡稳固了其作为亚洲财富管理中心的地位。</p><p>分析人士指出，新加坡吸引全球富豪的主要优势包括：稳定的政治环境、完善的法治体系、优惠的税收政策以及高质量的金融服务生态。此外，新加坡政府推出的"全球投资者计划"也为高净值人士提供了便捷的居留通道。</p><p>从来源地看，中国内地、印度、印度尼西亚、马来西亚和泰国的富豪是新加坡家族办公室的主要客户群体。值得注意的是，越来越多的欧洲和中东富豪也开始将部分资产转移至新加坡管理。</p><blockquote><p>新加坡已经确立了其作为亚洲首要财富管理中心的地位，这一趋势在未来几年将持续加强。——瑞士信贷亚太区CEO林伟杰</p></blockquote><p>然而，新加坡政府也在加强对家族办公室的监管，要求其将至少10%的管理资产投资于新加坡本地市场，以促进本土经济发展。</p>`,
    category: 'finance',
    categoryName: '财经',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Singapore%20Marina%20Bay%20skyline%20with%20iconic%20Marina%20Bay%20Sands%20hotel%20and%20financial%20district%20skyscrapers%20at%20sunset%20warm%20golden%20light%20reflecting%20on%20water%20professional%20cityscape%20photography%20with%20clean%20composition&width=800&height=500&seq=article-singapore-finance-01&orientation=landscape',
    author: '李明远',
    date: '2026-08-06',
    views: 72300,
    isHot: false,
    isFeatured: true,
    tags: ['新加坡', '家族办公室', '财富管理', '金融中心', '亚洲经济'],
  },
  {
    id: '7',
    title: '越南科技独角兽企业数量跃居东南亚第二，数字化转型加速推进',
    excerpt: '越南在2026年上半年新增3家科技独角兽企业，总数达到8家，超越印度尼西亚成为东南亚第二大独角兽聚集地。',
    content: `<p>据越南计划投资部最新数据，2026年上半年越南新增3家科技独角兽企业（估值超过10亿美元的未上市科技公司），使该国独角兽企业总数达到8家，超越印度尼西亚（7家），成为仅次于新加坡（18家）的东南亚第二大独角兽聚集地。</p><p>新晋独角兽包括：在线教育平台Edupia（估值12亿美元）、金融科技公司Finhay（估值15亿美元）和物流科技平台Scommerce（估值11亿美元）。这三家公司均受益于越南数字化转型的加速以及年轻消费群体的快速增长。</p><p>越南政府近年来大力推动数字经济发展，设定了到2030年数字经济占GDP比重达到30%的目标。目前，越南拥有近1亿人口，其中互联网普及率超过70%，智能手机普及率超过65%，为科技企业的发展提供了广阔的市场空间。</p><blockquote><p>越南拥有东南亚最具活力的创业生态系统之一，年轻、懂技术的人口是最大的优势。——越南科技部副部长阮辉勇</p></blockquote><p>不过，越南科技企业也面临着人才短缺和融资渠道有限等挑战，这需要政府和产业界的共同努力来解决。</p>`,
    category: 'tech',
    categoryName: '科技',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Ho%20Chi%20Minh%20City%20skyline%20at%20sunset%20with%20sleek%20skyscrapers%20and%20digital%20technology%20visualization%20elements%20blended%20warm%20amber%20and%20golden%20tones%20smart%20city%20concept%20professional%20architectural%20photography&width=800&height=500&seq=article-vietnam-tech-01&orientation=landscape',
    author: '王科技',
    date: '2026-08-05',
    views: 54100,
    isHot: false,
    isFeatured: false,
    tags: ['越南', '科技', '独角兽', '东南亚', '数字经济'],
  },
  {
    id: '8',
    title: '亚洲美食节东京站开幕，30国主厨联袂呈现饕餮盛宴',
    excerpt: '2026亚洲美食节在东京台场盛大开幕，来自30个亚洲国家和地区的主厨将在一周内呈现超过500道特色美食，预计吸引30万食客到场。',
    content: `<p>2026亚洲美食节于8月10日在东京台场盛大开幕，本届美食节以"舌尖上的亚洲"为主题，汇聚了来自30个亚洲国家和地区的顶级主厨，将在为期一周的活动中呈现超过500道各具特色的亚洲美食。</p><p>开幕式上，日本知名料理人山本征治与泰国米其林三星主厨Gaggan Anand联手献上了一场精彩的烹饪表演，融合了日式精致与泰式热情的创意料理赢得现场观众的热烈掌声。</p><p>本次美食节特别设置了"亚洲街头美食"专区，还原了台北士林夜市、曼谷考山路、首尔明洞等亚洲著名美食街区的氛围，让食客在东京就能体验到亚洲各地最地道的街头小吃。</p><blockquote><p>食物是了解亚洲文化最好的窗口，每一道菜都承载着一个地区的历史和故事。——亚洲美食节创始人松本健一</p></blockquote><p>主办方预计，本届美食节将吸引超过30万食客到场，创造约150亿日元的经济效益。下一届亚洲美食节计划于2027年在上海举办。</p>`,
    category: 'lifestyle',
    categoryName: '生活',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Asian%20food%20festival%20with%20colorful%20food%20stalls%20displaying%20various%20Asian%20cuisines%20steaming%20dishes%20decorative%20lanterns%20warm%20atmospheric%20lighting%20crowded%20festive%20atmosphere%20at%20night%20professional%20food%20photography&width=800&height=500&seq=article-food-festival-01&orientation=landscape',
    author: '陈美琳',
    date: '2026-08-10',
    views: 38900,
    isHot: false,
    isFeatured: false,
    tags: ['亚洲美食', '东京', '美食节', '餐饮文化', '亚洲生活'],
  },
  {
    id: '9',
    title: '日本动画电影《你的名字》续作官宣，新海诚回归执导',
    excerpt: '日本著名动画导演新海诚正式宣布《你的名字》续作将于2027年夏季上映，消息一经发布即登上全球社交媒体热搜。',
    content: `<p>日本动画界的重磅消息——著名导演新海诚于8月10日在东京举办新闻发布会，正式宣布将执导《你的名字》的官方续作，暂定名为《你的名字：重逢》（Your Name: Reunion），预计于2027年夏季在全球同步上映。</p><p>新海诚在发布会上透露，续作的故事将发生在原作结局的八年后，主角立花泷和宫水三叶在成年后将面临新的人生选择和挑战。影片将继续由RADWIMPS乐队负责音乐制作，延续前作令人难忘的音乐风格。</p><p>《你的名字》于2016年上映，全球票房超过3.8亿美元，至今仍保持着日本动画电影全球票房最高纪录。该片在中国内地创造了5.77亿元人民币的票房成绩，成为当时中国票房最高的日本电影。</p><blockquote><p>八年来我一直收到粉丝的来信，询问泷和三叶之后的故事。现在我觉得是时候把这个故事继续讲下去了。——新海诚</p></blockquote><p>消息发布后，#你的名字续作#话题迅速登上全球多个社交媒体的热搜榜，足见这部经典动画的持久影响力。</p>`,
    category: 'entertainment',
    categoryName: '娱乐',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20style%20cityscape%20at%20twilight%20with%20warm%20golden%20and%20pink%20sky%20traditional%20Tokyo%20buildings%20blended%20with%20modern%20architecture%20soft%20dreamy%20atmosphere%20cinematic%20composition%20with%20shooting%20stars&width=800&height=500&seq=article-anime-01&orientation=landscape',
    author: '张艺琳',
    date: '2026-08-10',
    views: 231500,
    isHot: true,
    isFeatured: true,
    tags: ['日本动画', '新海诚', '你的名字', '动漫', '电影'],
  },
  {
    id: '10',
    title: '亚洲数字货币监管框架逐步成型，多国推进CBDC试点',
    excerpt: '包括中国、日本、韩国、新加坡在内的多个亚洲国家正在加速推进央行数字货币的研发和试点工作，亚洲有望成为全球CBDC应用的先行区域。',
    content: `<p>随着数字经济的快速发展，亚洲各国正在加快构建数字货币监管框架，并积极推进央行数字货币（CBDC）的研发和试点工作。中国数字人民币试点已覆盖26个省市，累计交易额突破5万亿元人民币；日本央行已启动"数字日元"第二阶段概念验证；韩国央行预计将在2027年正式启动数字韩元试点。</p><p>新加坡金融管理局主导的"Project Orchid"项目已进入实质阶段，旨在探索可编程货币在跨境支付和政府发放补贴等场景中的应用。泰国、马来西亚、印度尼西亚等国也在各自的CBDC项目中取得了不同程度的进展。</p><blockquote><p>亚洲正在成为全球央行数字货币创新的领导者，各国之间的跨境互操作性合作将是下一步的关键。——国际清算银行创新中心负责人</p></blockquote><p>业内专家认为，亚洲在CBDC领域的领先优势得益于较高的移动支付普及率、政府的大力支持以及相对完善的技术基础设施。然而，数据隐私保护、网络安全以及与传统金融体系的兼容性等问题仍需各国审慎应对。</p>`,
    category: 'finance',
    categoryName: '财经',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20currency%20concept%20with%20glowing%20golden%20digital%20coins%20and%20blockchain%20network%20visualization%20on%20dark%20background%20warm%20amber%20and%20golden%20color%20scheme%20abstract%20technology%20design%20with%20clean%20geometric%20shapes&width=800&height=500&seq=article-cbdc-01&orientation=landscape',
    author: '李明远',
    date: '2026-08-04',
    views: 61800,
    isHot: false,
    isFeatured: false,
    tags: ['数字货币', 'CBDC', '数字人民币', '亚洲金融', '区块链'],
  },
  {
    id: '11',
    title: '台积电3纳米制程良率突破90%，苹果A19芯片将全面采用',
    excerpt: '台积电宣布其3纳米制程工艺良率已突破90%大关，新一代N3X工艺将为苹果A19芯片提供代工服务，预计2027年量产。',
    content: `<p>全球晶圆代工龙头台积电在最新技术论坛上宣布，其3纳米（N3）制程工艺良率已成功突破90%，标志着该技术节点的成熟度达到新高度。同时，台积电还公布了性能更强的N3X工艺，将在2027年为苹果下一代A19芯片提供代工服务。</p><p>台积电表示，N3X工艺相比标准N3工艺，在相同功耗下性能提升约15%，或在相同性能下功耗降低约30%。这一工艺将广泛应用于高性能计算、智能手机处理器和AI加速芯片等领域。</p><p>除苹果外，包括英伟达、AMD、英特尔等芯片巨头也都是台积电3纳米工艺的重要客户。台积电在亚洲的领先地位进一步巩固了亚洲在全球半导体产业中的核心地位。</p><blockquote><p>3纳米制程良率的突破是台积电技术实力的又一证明，我们将继续引领全球半导体制造技术的发展。——台积电CEO魏哲家</p></blockquote><p>与此同时，三星电子和英特尔也在积极追赶，全球先进制程的竞争愈发激烈。台积电表示，2纳米制程的研发进展顺利，预计2028年实现量产。</p>`,
    category: 'tech',
    categoryName: '科技',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20semiconductor%20chip%20manufacturing%20clean%20room%20with%20high-tech%20wafer%20processing%20equipment%20golden%20and%20amber%20circuit%20patterns%20on%20silicon%20wafer%20modern%20industrial%20design%20professional%20technology%20photography&width=800&height=500&seq=article-tsmc-01&orientation=landscape',
    author: '王科技',
    date: '2026-08-03',
    views: 87200,
    isHot: true,
    isFeatured: false,
    tags: ['台积电', '芯片', '半导体', '3纳米', '苹果'],
  },
  {
    id: '12',
    title: '马来西亚榴莲季火热开启，猫山王价格创历史新高',
    excerpt: '马来西亚2026年榴莲季正式拉开帷幕，受全球需求激增和中国市场强劲需求推动，猫山王榴莲产地价格突破每公斤120林吉特。',
    content: `<p>马来西亚一年一度的榴莲季于8月初正式拉开帷幕，被誉为"水果之王"的榴莲再次成为亚洲美食爱好者的焦点。今年受厄尔尼诺现象导致的减产以及全球需求激增的双重影响，猫山王榴莲的产地价格已突破每公斤120林吉特（约合26美元），创下历史新高。</p><p>马来西亚榴莲出口商协会表示，2026年马来西亚榴莲出口额预计将突破30亿林吉特，其中中国市场占据了约75%的份额。中国消费者对猫山王榴莲的追捧热情持续高涨，推动了整个产业链的蓬勃发展。</p><p>今年，马来西亚农业部和旅游局联合推出了"2026榴莲之旅"活动，邀请全球游客前往彭亨州劳勿和槟城等榴莲产区，体验新鲜的"树下吃榴莲"文化。</p><blockquote><p>榴莲已经从一种热带水果变成了连接亚洲各国的文化纽带。——马来西亚农业部长莫哈末沙布</p></blockquote><p>不过，面对不断上涨的价格，不少马来西亚本地消费者表示"压力山大"，呼吁政府采取措施保障国内供应。</p>`,
    category: 'lifestyle',
    categoryName: '生活',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Musang%20King%20durians%20displayed%20on%20a%20rustic%20wooden%20table%20at%20a%20tropical%20fruit%20farm%20in%20Malaysia%20warm%20natural%20sunlight%20lush%20green%20tropical%20background%20professional%20food%20photography%20with%20rich%20golden%20and%20green%20tones&width=800&height=500&seq=article-durian-01&orientation=landscape',
    author: '陈美琳',
    date: '2026-08-02',
    views: 45600,
    isHot: false,
    isFeatured: false,
    tags: ['马来西亚', '榴莲', '猫山王', '亚洲美食', '水果'],
  },
  {
    id: '13',
    title: '亚洲电竞市场持续增长，2026年全球赛事总奖金突破5亿美元',
    excerpt: '亚洲电竞产业在2026年继续保持高速增长，全球电竞赛事总奖金池突破5亿美元，其中亚洲地区贡献了超过60%的观众和赞助收入。',
    content: `<p>根据Newzoo最新发布的全球电竞市场报告，2026年全球电竞赛事总奖金池达到5.2亿美元，同比增长18%。亚洲地区贡献了超过60%的电竞观众和约55%的赞助收入，继续巩固其全球电竞产业核心地位。</p><p>中国、韩国和东南亚是亚洲电竞的三大主要市场。中国以超过4.8亿电竞用户位居全球第一，韩国则在职业化程度和人才培养体系方面保持领先。东南亚地区凭借庞大且年轻的人口基数，正在成为电竞产业增长最快的区域之一。</p><p>2026年杭州亚运会上，电子竞技将第二次作为正式比赛项目亮相，包括《英雄联盟》《王者荣耀》《和平精英》等8个项目。这一里程碑事件将进一步推动电竞的体育化进程。</p><blockquote><p>亚洲不仅是电竞最大的市场，也是电竞文化最深厚的土壤。这里的年轻人正在重新定义体育和娱乐的边界。——亚洲电竞联合会主席霍启刚</p></blockquote><p>与此同时，电竞教育、电竞旅游、电竞地产等衍生业态也在亚洲各地蓬勃发展。</p>`,
    category: 'entertainment',
    categoryName: '娱乐',
    image: 'https://readdy.ai/api/search-image?query=Massive%20esports%20arena%20with%20thousands%20of%20spectators%20colorful%20stage%20lighting%20and%20giant%20LED%20screens%20displaying%20game%20action%20energetic%20crowd%20atmosphere%20professional%20event%20photography%20with%20dramatic%20lighting%20effects&width=800&height=500&seq=article-esports-01&orientation=landscape',
    author: '张艺琳',
    date: '2026-08-01',
    views: 108900,
    isHot: true,
    isFeatured: false,
    tags: ['电竞', '亚洲电竞', '电竞赛事', '游戏产业', '亚运会'],
  },
  {
    id: '14',
    title: '香港虚拟资产交易平台发牌制度全面实施，合规化进程加速',
    excerpt: '香港证监会宣布虚拟资产交易平台发牌制度将于2026年9月全面实施，已有12家平台获得原则性批准，标志着亚洲数字资产合规化进入新阶段。',
    content: `<p>香港证券及期货事务监察委员会（证监会）宣布，虚拟资产交易平台发牌制度将于2026年9月1日起全面实施，未持牌平台将被禁止在香港营运或向香港投资者提供服务。截至目前，已有12家平台获得原则性批准，其中包括HashKey、OSL等本地平台以及部分国际知名交易所。</p><p>分析人士认为，香港的虚拟资产监管框架为亚洲其他地区提供了重要参考。与新加坡、日本、韩国等地的监管政策相比，香港采取了相对平衡的监管立场——既能保护投资者权益，又不扼杀行业创新。</p><blockquote><p>香港正在成为连接传统金融和数字资产的重要枢纽，我们的监管框架将为行业的长期健康发展奠定基础。——香港证监会行政总裁梁凤仪</p></blockquote><p>市场预计，随着监管框架的明确，更多传统金融机构将进入虚拟资产领域，推动整个亚洲数字资产市场的合规化和机构化进程。</p>`,
    category: 'finance',
    categoryName: '财经',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20skyline%20at%20night%20with%20modern%20skyscrapers%20and%20Victoria%20Harbour%20digital%20financial%20technology%20visualization%20elements%20blended%20in%20warm%20golden%20and%20amber%20city%20lights%20professional%20cityscape%20photography&width=800&height=500&seq=article-hk-crypto-01&orientation=landscape',
    author: '李明远',
    date: '2026-07-31',
    views: 74200,
    isHot: false,
    isFeatured: false,
    tags: ['香港', '虚拟资产', '加密货币', '监管', '数字资产'],
  },
  {
    id: '15',
    title: '亚洲5G用户突破20亿，6G研发竞赛悄然打响',
    excerpt: 'GSMA最新报告显示亚洲5G连接数已突破20亿，中国、韩国、日本领跑。与此同时，中日韩三国已率先启动6G技术研发。',
    content: `<p>全球移动通信系统协会（GSMA）最新报告显示，截至2026年中，亚洲地区5G连接数已突破20亿，占全球5G连接总数的65%以上。其中，中国以超过12亿5G用户遥遥领先，韩国以超过95%的人口覆盖率位居5G普及率榜首，日本、印度和东南亚各国的5G部署也在快速推进中。</p><p>在5G应用方面，亚洲同样走在前列。中国的智慧工厂、智慧港口应用，韩国的AR/VR直播，日本的远程医疗和自动驾驶等5G应用场景都在大规模落地。</p><p>而在5G尚未完全普及之时，6G的研发竞赛已经悄然打响。中国、日本、韩国均已成立了国家级6G研发项目，并设定了2030年前后实现商用的目标。</p><blockquote><p>6G将不仅仅是通信技术的升级，它将彻底改变人、机、物之间的交互方式。——国际电信联盟秘书长多琳</p></blockquote><p>专家预计，6G将实现太赫兹级别的传输速率、亚毫秒级的延迟和厘米级的定位精度。</p>`,
    category: 'tech',
    categoryName: '科技',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20smart%20city%20with%205G%20network%20visualization%20glowing%20digital%20waves%20connecting%20modern%20buildings%20warm%20amber%20and%20golden%20technology%20theme%20clean%20futuristic%20design%20with%20flowing%20data%20streams%20professional%20visual&width=800&height=500&seq=article-5g-01&orientation=landscape',
    author: '王科技',
    date: '2026-07-30',
    views: 65300,
    isHot: false,
    isFeatured: false,
    tags: ['5G', '6G', '通信技术', '亚洲科技', '移动通信'],
  },
  {
    id: '16',
    title: '亚洲瑜伽热潮持续升温，线上线下融合模式成为新趋势',
    excerpt: '亚洲瑜伽市场规模预计2026年突破500亿美元，印度、中国和东南亚成为增长最快的三大市场，线上线下融合模式成为行业新趋势。',
    content: `<p>据国际瑜伽联合会最新报告，2026年亚洲瑜伽市场规模预计突破500亿美元，占全球瑜伽市场约45%的份额。印度作为瑜伽发源地，继续保持全球最大瑜伽市场的地位；中国市场规模已跃居亚洲第二，东南亚则成为增长最快的区域。</p><p>受疫情影响加速的数字化转型正在重塑瑜伽行业。线上瑜伽课程、AI瑜伽教练和虚拟现实瑜伽等新模式快速涌现，与传统的线下瑜伽馆形成了互补共生的关系。头部瑜伽平台如中国的Keep、印度的SARVA等已实现线上线下深度融合。</p><p>值得注意的是，企业瑜伽福利正在成为亚洲职场新趋势。越来越多的亚洲企业将瑜伽课程纳入员工健康福利计划，以帮助员工缓解工作压力、提升身心健康。</p><blockquote><p>瑜伽已经超越了单纯的身体锻炼，成为一种追求身心平衡的生活方式，这正是它在快节奏的亚洲社会广受欢迎的原因。——国际瑜伽联合会主席</p></blockquote><p>随着亚洲中产阶级的持续扩大和健康意识的不断提升，瑜伽市场仍有巨大的增长空间。</p>`,
    category: 'lifestyle',
    categoryName: '生活',
    image: 'https://readdy.ai/api/search-image?query=Serene%20yoga%20studio%20with%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%20group%20of%20people%20practicing%20yoga%20on%20wooden%20floor%20minimalist%20design%20with%20indoor%20plants%20peaceful%20atmosphere%20professional%20lifestyle%20photography&width=800&height=500&seq=article-yoga-01&orientation=landscape',
    author: '陈美琳',
    date: '2026-07-29',
    views: 32100,
    isHot: false,
    isFeatured: false,
    tags: ['瑜伽', '健康生活', '亚洲生活', '健身', '身心健康'],
  },
  {
    id: '17',
    title: '亚洲影视流媒体竞争升级，Netflix亚洲用户突破1亿',
    excerpt: 'Netflix宣布亚洲地区付费用户突破1亿大关，Disney+和本土平台也在加速布局，亚洲流媒体市场竞争进入白热化阶段。',
    content: `<p>Netflix首席执行官在最新财报电话会议中宣布，公司在亚洲地区的付费用户已突破1亿大关，亚洲已成为Netflix全球增长最快的区域市场。韩国原创内容如《鱿鱼游戏》《黑暗荣耀》等的全球成功，是驱动亚洲用户增长的关键因素。</p><p>与此同时，Disney+也在加大亚洲市场的投入，2026年计划在亚太地区推出超过50部本地原创内容。日本动漫、韩国电视剧和中国武侠题材是Disney+在亚洲的重点布局方向。</p><p>值得注意的是，亚洲本土流媒体平台也在强势崛起。中国的爱奇艺、腾讯视频，韩国的TVING，日本的U-Next等都在积极拓展区域市场，形成了与全球巨头分庭抗礼的格局。</p><blockquote><p>亚洲流媒体市场的独特之处在于，本地内容和本地文化的理解是核心竞争力，这方面本土平台具有天然优势。——亚洲传媒研究机构Media Partners Asia</p></blockquote><p>预计到2027年，亚洲流媒体市场总规模将突破600亿美元。</p>`,
    category: 'entertainment',
    categoryName: '娱乐',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20TV%20screen%20displaying%20colorful%20streaming%20content%20interface%20cozy%20living%20room%20with%20warm%20ambient%20lighting%20professional%20interior%20photography%20with%20cinematic%20atmosphere&width=800&height=500&seq=article-streaming-01&orientation=landscape',
    author: '赵亚洲',
    date: '2026-07-28',
    views: 89500,
    isHot: false,
    isFeatured: false,
    tags: ['流媒体', 'Netflix', '亚洲影视', 'Disney+', '娱乐产业'],
  },
  {
    id: '18',
    title: '亚洲私募股权市场2026上半年交易额突破3000亿美元',
    excerpt: '贝恩咨询报告显示，2026年上半年亚洲私募股权交易总额达到3120亿美元，科技、医疗健康和新能源成为最受资本追捧的三大赛道。',
    content: `<p>贝恩咨询最新发布的《2026年亚洲私募股权市场半年报》显示，2026年上半年亚洲私募股权交易总额达到3120亿美元，同比增长22%，创下历史同期最高纪录。其中，科技领域以980亿美元的交易额位居各行业之首，医疗健康和新能源分别以650亿美元和580亿美元紧随其后。</p><p>从地域分布来看，中国（含香港）以1450亿美元的交易额占据近半壁江山，印度以520亿美元排名第二，日本和东南亚分别以380亿美元和350亿美元位列第三和第四。</p><p>值得注意的是，亚洲私募股权基金的募资规模也在持续扩大。2026年上半年，亚洲PE基金共募集资金1850亿美元，超过2025年全年的60%。</p><blockquote><p>亚洲市场拥有全球最丰富的中长期增长故事，科技升级、消费升级和绿色转型这三大主题将持续驱动投资机会。——贝恩咨询全球合伙人韩微文</p></blockquote><p>不过，地缘政治风险和估值压力是投资者需要重点关注的两大挑战。</p>`,
    category: 'finance',
    categoryName: '财经',
    image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20charts%20and%20data%20visualization%20on%20modern%20office%20desk%20with%20warm%20ambient%20lighting%20clean%20minimalist%20design%20golden%20and%20amber%20color%20accents%20corporate%20atmosphere%20professional%20business%20photography&width=800&height=500&seq=article-pe-01&orientation=landscape',
    author: '李明远',
    date: '2026-07-27',
    views: 48700,
    isHot: false,
    isFeatured: false,
    tags: ['私募股权', '亚洲投资', '资本市场', '科技投资', '并购'],
  },
  {
    id: '19',
    title: '印尼新首都努桑塔拉建设加速，2026年首批政府机构完成迁移',
    excerpt: '印度尼西亚新首都努桑塔拉的建设正在加速推进，2026年底前将有12个中央政府部门的约1.5万名公务员完成迁移。',
    content: `<p>印度尼西亚总统佐科·维多多近日视察了位于东加里曼丹省的新首都努桑塔拉（Nusantara）建设工地，并宣布2026年底前将有12个中央政府部门的约1.5万名公务员完成迁移，标志着这一东南亚最大规模的城市迁建项目进入关键阶段。</p><p>努桑塔拉新首都的概念规划面积约2560平方公里，是雅加达面积的近四倍。新首都将按照"智慧森林城市"理念建设，目标是成为碳中和的可持续发展示范区。项目总投资预计超过340亿美元。</p><p>目前，总统府、各部委办公楼、公务员住宅等核心设施已基本完工。配套的基础设施建设，包括机场、高速公路、供水系统和绿色能源设施也在加速推进中。</p><blockquote><p>努桑塔拉不仅是印尼的新首都，更是展示我们建设可持续未来城市决心的标志性项目。——印尼总统佐科·维多多</p></blockquote><p>然而，项目也面临着资金来源、环境保护和原住民权益等多方面的挑战和争议。</p>`,
    category: 'tech',
    categoryName: '科技',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20eco-friendly%20smart%20city%20with%20modern%20green%20architecture%20surrounded%20by%20lush%20tropical%20rainforest%20warm%20golden%20sunset%20lighting%20sustainable%20urban%20design%20concept%20professional%20architectural%20visualization&width=800&height=500&seq=article-nusantara-01&orientation=landscape',
    author: '王科技',
    date: '2026-07-26',
    views: 43200,
    isHot: false,
    isFeatured: false,
    tags: ['印尼', '新首都', '努桑塔拉', '智慧城市', '东南亚'],
  },
  {
    id: '20',
    title: '亚洲咖啡文化崛起：从上海到首尔，精品咖啡店数量超越欧洲',
    excerpt: '世界咖啡协会报告指出，亚洲精品咖啡店数量已超过欧洲，上海以超过8000家咖啡店位居全球城市之首，亚洲正在重新定义全球咖啡文化。',
    content: `<p>世界咖啡协会最新发布的《2026全球咖啡文化报告》揭示了一个引人注目的趋势：亚洲精品咖啡店的总数已超过欧洲，成为全球最大的精品咖啡消费市场。上海以超过8000家咖啡店位居全球城市之首，首尔、东京、台北和新加坡等亚洲城市也位列前茅。</p><p>报告指出，亚洲咖啡文化的崛起得益于多重因素：快速扩大的中产阶级、日益西化的生活方式、社交媒体的推广效应，以及亚洲消费者对品质和体验的高要求。值得注意的是，亚洲精品咖啡市场并非简单复制西方模式，而是融入了独特的本土文化元素。</p><p>在上海，结合了中国传统茶文化的"茶咖"概念正在流行；在首尔，韩式复古风格的咖啡店成为年轻人社交的首选场所；在曼谷，热带风情的花园咖啡则展现了东南亚特色。</p><blockquote><p>亚洲正在以自己独特的方式重新定义咖啡文化，这不仅仅是消费习惯的改变，更是一种生活美学的创造。——世界咖啡协会主席</p></blockquote><p>中国云南、越南和印度尼西亚等亚洲咖啡产区的品质也在不断提升，正在改变全球精品咖啡的供应链格局。</p>`,
    category: 'lifestyle',
    categoryName: '生活',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20Asian%20specialty%20coffee%20shop%20interior%20with%20warm%20minimalist%20design%20wooden%20furniture%20barista%20pouring%20latte%20art%20soft%20natural%20lighting%20cozy%20atmosphere%20professional%20interior%20photography&width=800&height=500&seq=article-coffee-01&orientation=landscape',
    author: '陈美琳',
    date: '2026-07-25',
    views: 51800,
    isHot: false,
    isFeatured: false,
    tags: ['咖啡文化', '亚洲生活', '精品咖啡', '上海', '首尔'],
  },
];

export const featuredArticles = articles.filter(a => a.isFeatured);
export const hotArticles = articles.filter(a => a.isHot);
export const getArticlesByCategory = (slug: string) => articles.filter(a => a.category === slug);
export const getArticleById = (id: string) => articles.find(a => a.id === id);
export const getRelatedArticles = (article: Article, limit: number = 4) =>
  articles.filter(a => a.category === article.category && a.id !== article.id).slice(0, limit);
export const getLatestArticles = (limit: number = 6) =>
  [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);